import { CascaderOptionType } from 'antd/lib/cascader'
import {
  BranchOfficeDto,
  BusinessUnitWithManagersDto,
  CompanyManagerAppraisalMeetingStatusTableRowDto,
  DashboardListOfCompanies,
  EmployeeLevelEnum,
  EmployeeWithLevelDto,
  RoleName,
} from '../../types'
import { AppraisalMonitoringTableStatusFilter } from './utils/appraisalMeetingStatusDashboardUtil'

export enum MonitoringTabs {
  CHART = 'chart',
  TABLE = 'table',
}

export enum FiltersTabs {
  OFFICE = 'Office',
  BUSINESS_UNIT = 'Business Unit',
  BUMANAGERS = 'BU Managers',
}

export type DashboardSelectorValue = {
  label: string
  value: string
}

export type AppraisalMonitoringFiltersState = {
  selectedBranchOffice?: BranchOfficeDto
  selectedBusinessUnit?: BusinessUnitWithManagersDto
  selectedBuManager?: EmployeeWithLevelDto
  selectedEmployeeLevels?: { label: string; value: EmployeeLevelEnum[] }
}

export type DistributionBubobumCounters = {
  businessUnit: number
  buManagers: number
  branchOffice: number
}

export interface DashboardState {
  storeInitialized: boolean
  companies: DashboardListOfCompanies[]
  companiesForSelection: CascaderOptionType[]
  countriesForSelection: CascaderOptionType[]
  selected: DashboardSelectorValue
  selectedCountry: DashboardSelectorValue
  selectedDashboardRoles: RoleName[]
  activeMonitoringTab: MonitoringTabs
  activeFiltersTab: FiltersTabs
  distributionBubobumCounters: DistributionBubobumCounters | null
  appraisalMonitoringFilters: AppraisalMonitoringFiltersState
  appraisalMonitoringAllRows: CompanyManagerAppraisalMeetingStatusTableRowDto[]
  appraisalMonitoringFilteredRows: CompanyManagerAppraisalMeetingStatusTableRowDto[]
  appraisalMonitoringOngoingUpdatesCount: number
  appraisalMonitoringTableStatus?: AppraisalMonitoringTableStatusFilter

  initStore: (companies: DashboardListOfCompanies[]) => void
  setActiveMonitoringTab: (activeMonitoringTab: MonitoringTabs) => void
  setActiveFiltersTab: (activeFiltersTab: FiltersTabs) => void
  setDistributionBubobumCounters: (counters: DistributionBubobumCounters) => void
  setAppraisalMonitoringData: (payload: {
    rows: CompanyManagerAppraisalMeetingStatusTableRowDto[]
    ongoingAppraisalUpdateAfterLatestConfirmedMeetingCount: number
  }) => void
  setAppraisalMonitoringFilters: (filters: AppraisalMonitoringFiltersState) => void
  setAppraisalMonitoringEmployeeLevel: (labelPill: string) => void
  clearAppraisalMonitoringFilters: () => void
  setAppraisalMonitoringTableStatus: (status?: AppraisalMonitoringTableStatusFilter) => void
  setSelected: (companyValue: string) => void
  setSelectedCountry: (countryValue: string) => void
}
